import React, { useState } from "react";
import Modal from "./Modal";
import MeetingAttendee from "./MeetingAttendee";

const MeetingAttendeeList = ({ guests }) => {
  const [attendeeDetails, setAttendeeDetails] = useState(null);
  const [showAttendeeModal, setShowAttendeeModal] = useState(false);

  const onDisplayAttendeeDetails = (attendee) => {
    setAttendeeDetails(attendee);
    setShowAttendeeModal(true);
  };

  return (
    <React.Fragment>
      <div className="guestlist">
        <ul className="list-unstyled m-0">
          {!!guests &&
            guests
              .sort((guestA, guestB) => {
                if (guestA.isHost) return -1;
                if (guestB.isHost) return 1;
                return 0;
              })
              .map((guest, i) => (
                <li className="guestlist-item px-3 py-3" key={guest.ProfileID}>
                  <MeetingAttendee
                    guest={guest}
                    displayAttendeeDetails={onDisplayAttendeeDetails}
                  />
                </li>
              ))}
        </ul>
      </div>

      {attendeeDetails && (
        <Modal
          title="Attendee Details"
          show={showAttendeeModal}
          hideFooter={true}
          onClose={() => {
            setShowAttendeeModal(false);
          }}
        >
          <h3>{attendeeDetails.name}</h3>
          <h4>{attendeeDetails.company}</h4>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default MeetingAttendeeList;
